import type { SupVaultReward } from "@/types";
import React from "react";

import { SupText } from "@repo/core-ui";
import config from "@/../config/dapp.config";

interface UiLabelRewardsValueProps {
  reward: SupVaultReward;
}

export default function UiLabelRewardsValue({ reward }: UiLabelRewardsValueProps) {
  return (
    <>
      {reward.rate_type !== "earning" ? (
        <div className="flex flex-col items-end">
          <SupText variant="subtitle2" className="h-3">
            +{reward.reward_rate.toFixed(config.decimalsApyRoundingLimit)}
            {reward.type === "token" ? "%" : ""}
          </SupText>
          {reward.type === "points" && (
            <SupText variant="detail" className="h-3 leading-3">
              {reward.rate_type}
            </SupText>
          )}
        </div>
      ) : (
        reward.reward_multiplier > 0 && (
          <div className="flex flex-col items-end">
            <SupText variant="caption" className="h-3 leading-3">
              {reward.reward_multiplier}X
            </SupText>
          </div>
        )
      )}
    </>
  );
}
